/** Shared dialog title close button — 22×22 hit area, 16px icon, Figma-aligned color. */
export const DIALOG_CLOSE_BUTTON_SX = {
  flexShrink: 0,
  width: 22,
  height: 22,
  minWidth: 22,
  minHeight: 22,
  p: 0,
  color: "rgba(0, 0, 0, 0.45)",
  "&:hover": { backgroundColor: "rgba(0, 0, 0, 0.04)" },
  "& .MuiSvgIcon-root": { width: 16, height: 16, fontSize: 16 },
} as const;
